import { z } from 'zod';

const errorDetailZod = z.object({
  code: z.string(),
  message: z.string(),
  target: z.string().nullable().optional(),
});

/** ASP.NET model validation failures: field name -> list of problems */
const validationErrorZod = z.record(z.array(z.string()));

/**
 * Error schema for the data services annotations api.
 * The backend uses several body shapes, so each is normalized to `{ error: { code, message, target } }`:
 * - writes (PATCH/POST) wrap the detail: `{ error: { code, message, target } }`
 * - reads (GET 404) return the detail at the top level: `{ code, message, target }`
 * - request validation (400) returns `{ FieldName: ['problem', ...] }`
 */
export const AnnotationsBackEndErrorSchema = z.union([
  z.object({ error: errorDetailZod }),
  errorDetailZod.transform((error) => ({ error })),
  validationErrorZod.transform((fields) => ({
    error: {
      code: 'ValidationError',
      message: Object.entries(fields)
        .map(([field, problems]) => `${field}: ${problems.join(' ')}`)
        .join('; '),
      target: null,
    },
  })),
]);
export type AnnotationsBackEndError = z.output<
  typeof AnnotationsBackEndErrorSchema
>;
